import { Check } from "@phosphor-icons/react";

/** Horizontal progress stepper — numbered chips + connecting rules. */
export const Stepper = ({ steps, current, onStep, testid = "stepper" }) => (
  <div className="flex items-center" data-testid={testid}>
    {steps.map((s, i) => {
      const done = i < current;
      const active = i === current;
      const clickable = onStep && i <= current;
      return (
        <div key={s.key} className="flex items-center flex-1 last:flex-none min-w-0">
          <button
            type="button"
            disabled={!clickable}
            onClick={() => clickable && onStep(i)}
            aria-current={active ? "step" : undefined}
            data-testid={`${testid}-step-${s.key}`}
            className={`flex items-center gap-2.5 min-w-0 ${clickable ? "cursor-pointer" : "cursor-default"}`}
          >
            <span
              className={`shrink-0 w-8 h-8 rounded-full border flex items-center justify-center text-xs tnum transition-colors duration-200 ${
                active
                  ? "bg-primary text-primary-foreground border-primary font-semibold"
                  : done
                    ? "bg-primary/15 text-primary border-primary/40"
                    : "bg-transparent text-muted-foreground border-border"
              }`}
            >
              {done ? <Check size={13} weight="bold" /> : i + 1}
            </span>
            <span className={`text-xs uppercase tracking-[0.14em] hidden sm:block truncate ${active ? "text-foreground" : "text-muted-foreground"}`}>
              {s.label}
            </span>
          </button>
          {i < steps.length - 1 && (
            <span className={`flex-1 h-px mx-3 ${done ? "bg-primary/40" : "bg-border"}`} />
          )}
        </div>
      );
    })}
  </div>
);

export default Stepper;
